<script setup lang="ts">
import DialogCloseIcon from "@/assets/editViewIcons/DialogCloseIcon.vue";
import NamaIcon from "@/components/icons/NamaIcon.vue";
import {useDialogPluginComponent} from "quasar";
import {useQRCode} from '@vueuse/integrations/useQRCode'
import {useLoginInfoStore} from "@/stores/loginInfo.ts";
import NamaCommon, {NamaAxiosRequestConfig} from "@/utils/common/NamaCommon.ts";
import NamaURLS from "@/utils/constants/NamaURLS.ts";
import {onMounted, ref} from "vue";
import {Cookies} from "typescript-cookie";
import Translator from "@/utils/common/Translator.ts";
import DTOAppsDefaultSettings = namaTypes.DTOAppsDefaultSettings;

const {dialogRef, onDialogCancel} = useDialogPluginComponent()
const {loginInfo} = useLoginInfoStore()
const qrInfo = ref()

async function getQRInfo() {
  const pathName = window.location.href.replace(window.location.hash, "").replace(window.location.search, "")
    .replace("#", "").replace("erp.html", "")
    .replace("erp5.html", "").replace("erp1.html", "")
    .replace("vuedev.html", "").replace("vue.html", "");
  const settings: NamaAxiosRequestConfig = {
    params: {
      loginInfo: JSON.stringify({
        deviceId: Cookies.get("dmsdeviceid"),
      })
    },
    noLoadingIndicator: true,
  }
  let data: DTOAppsDefaultSettings | null = null;
  const result = await NamaCommon.namaFetch(NamaURLS.APPS_CONFIG, settings)
  if (NamaCommon.isSuccess(result))
    data = result as DTOAppsDefaultSettings
  const qrData = {
    user: loginInfo?.userInfo?.code ?? "",
    deviceCode: loginInfo?.userInfo?.code ?? "",
    adminPin: data?.defaultAdminPin ?? "",
    email: data?.defaultEmail ?? "",
    printingSdkVersion: data?.defaultPrintingSdkVersion ?? "",
    url: data?.serverUrl || pathName,
  }
  qrInfo.value = JSON.stringify(qrData)
}

const qrcode = useQRCode(qrInfo)

onMounted(async () => {
  await getQRInfo()
})

</script>

<template>
  <q-dialog ref="dialogRef" transition-hide="jump-down" transition-show="jump-up">
    <q-card class="tw-relative tw-w-[450px] dark:tw-bg-namaBackground-deep-dark tw-px-4 tw-py-3 !tw-rounded-xl" dir="ltr">
      <div class="tw-flex tw-justify-between tw-items-center">
        <div class="tw-flex tw-items-center tw-gap-2">
          <NamaIcon default-icon="qr_code" class="!tw-text-[35px]"/>
          <p v-text="'QR Info'" class="tw-text-lg tw-font-semibold tw-leading-none dark:tw-text-white"/>
        </div>
        <q-avatar square class="tw-size-5  tw-cursor-pointer" @click="onDialogCancel">
          <DialogCloseIcon/>
        </q-avatar>
      </div>
      <q-separator class="tw-my-2 dark:tw-bg-white/10"/>
      <q-card-section class="!tw-p-2 tw-w-full tw-flex tw-flex-col tw-gap-2 tw-items-center">
        <div class="tw-bg-primary-light tw-p-6 tw-pt-6 tw-pb-10  tw-rounded-md tw-w-full">
          <div v-text="'Scan this QR Code'" class="tw-text-white tw-text-xl tw-mb-2 tw-font-semibold tw-text-center"/>
          <div class="tw-w-full tw-relative">
            <q-img :title="qrInfo" :src="qrcode"
                   class="tw-max-w-64  tw-rounded-lg tw-mx-auto tw-block tw-border tw-border-gray-200"
                   alt="QR Code"/>
          </div>
        </div>
        <div class="tw-w-full tw-text-center">
          <div v-text="'Application Urls'" class="tw-font-semibold tw-text-lg tw-mt-2 tw-mb-2 dark:tw-text-white"/>
          <div class="tw-w-full tw-grid tw-grid-cols-2 tw-gap-2">
            <q-btn class="tw-rounded-md tw-shadow-sm nama-light-shadow" unelevated
                   :href="Translator.translateIdEn('mobileAndroidUrl')"
                   target="_blank">
              <div class="tw-flex tw-gap-2 tw-items-center">
                <NamaIcon default-icon="nm-google-play" class="tw-size-5"/>
                <span v-text="'Google Play'" class="tw-capitalize dark:tw-text-white"/>
              </div>
            </q-btn>
            <q-btn class="tw-rounded-md tw-shadow-sm nama-light-shadow" unelevated
                   :href="Translator.translateIdEn('mobileIOSUrl')"
                   target="_blank">
              <div class="tw-flex tw-gap-2 tw-items-center">
                <NamaIcon default-icon="nm-app-store" class="tw-size-5"/>
                <span v-text="'App Store'" class="tw-capitalize dark:tw-text-white"/>
              </div>
            </q-btn>
          </div>
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>
